import type { FC } from 'react';
import { TextSkeleton } from 'src/modules/shared/components/atoms/text/text-skeleton';
import { Panel } from 'src/modules/shared/components/molecules/panel';
import type { PropertyEditorPageSkeletonProps } from '../../types/property-editor-page.type';

/** Renders the editor layout while its property and permissions resolve. */
export const PropertyEditorPageSkeleton: FC<
  PropertyEditorPageSkeletonProps
> = ({ showRail }) => (
  <div className="flex h-full min-h-0 flex-col">
    <Panel className="flex h-full min-h-0 flex-col">
      <div className="border-b border-slate-200 px-4 py-4 sm:px-6">
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-3">
            <TextSkeleton className="h-10 w-64 rounded-lg" />
            <TextSkeleton className="h-6 w-96 max-w-[80vw] rounded-lg" />
          </div>
          <TextSkeleton className="h-11 w-28 rounded-xl" />
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-auto bg-slate-50">
        <div
          className={`mx-auto grid w-full max-w-7xl items-start grid-cols-1 gap-5 p-4 ${
            showRail ? 'xl:grid-cols-[minmax(0,1fr)_360px]' : ''
          }`}
        >
          <div className="flex flex-col gap-5">
            <TextSkeleton className="h-64 rounded-3xl" />
            <TextSkeleton className="h-44 rounded-3xl" />
            <TextSkeleton className="h-72 rounded-3xl" />
            <TextSkeleton className="h-56 rounded-3xl" />
          </div>

          {showRail ? (
            <div className="flex flex-col gap-5">
              <TextSkeleton className="h-52 rounded-3xl" />
              <TextSkeleton className="h-64 rounded-3xl" />
            </div>
          ) : null}
        </div>
      </div>
    </Panel>
  </div>
);
